<template>
  <ul
    class="sb-pagination-links pagination pagination-sm"
    data-sb-regression="sb-pagination-links"
  >
    <li
      v-if="$slots['page-link-previous']"
      class="page-item page-item-previous"
      data-sb-automation="previous-page"
      @click="prevPage()"
    >
      <!--
        @slot slot to show link to previous page
      -->
      <slot name="page-link-previous" />
    </li>
    <template v-if="$slots['page-links']">
      <template
        v-for="n in calculatedRange"
        :key="n"
      >
        <li
          :class="calcNumberedPageLinkClasses(isActive(n))"
          :data-sb-automation="`specific-page-${n}`"
          @click="goToPage(n)"
        >
          <!--
            @slot slot to show buttons to various pages
          -->
          <slot
            name="page-links"
            :page="n"
            :active="isActive(n)"
          />
        </li>
      </template>
    </template>
    <li
      v-if="$slots['page-link-next']"
      class="page-item page-item-next"
      data-sb-automation="next-page"
      @click="nextPage()"
    >
      <!--
        @slot slot to show link to next page
      -->
      <slot name="page-link-next" />
    </li>
  </ul>
</template>

<script>
export default {
  name: 'SbPaginationLinks',
  inject: ['pagination', 'fetchPage'],
  props: {
    range: {
      type: Number,
      default: 5,
    },
  },
  computed: {
    currentPage() {
      return this.pagination.currentPage;
    },
    totalPages() {
      return this.pagination.totalPages;
    },
    totalPagesPlus() {
      return this.totalPages + 1;
    },
    calculatedRange() {
      const mid = Math.floor(this.range / 2);
      let lowBound = this.currentPage - mid;
      if (this.currentPage - mid <= 0 || this.totalPages - this.range <= 0) {
        lowBound = 1;
      } else if (this.currentPage + mid > this.totalPages) {
        lowBound = this.totalPages - this.range + 1;
      }
      return [...new Array(Math.min(this.range, this.totalPages))].map((n, i) => i + lowBound);
    },
  },
  methods: {
    prevPage() {
      let newPageNumber = (this.currentPage - 1 + this.totalPagesPlus) % this.totalPagesPlus;
      if (newPageNumber === 0) newPageNumber = this.totalPages;
      this.fetchPage(newPageNumber);
    },
    nextPage() {
      let newPageNumber = (this.currentPage + 1) % this.totalPagesPlus;
      if (newPageNumber === 0) newPageNumber = 1;
      this.fetchPage(newPageNumber);
    },
    goToPage(newPageNumber) {
      this.fetchPage(newPageNumber);
    },
    calcNumberedPageLinkClasses(isActive) {
      const classes = ['page-item'];
      if (isActive) classes.push('active');
      return classes;
    },
    isActive(n) {
      return n === this.currentPage;
    },
    showPageLink(pageNum) {
      return pageNum > 0 && pageNum <= this.totalPages;
    },
  },
};
</script>

<style lang="scss">
@import '@src/components/Pagination/style/sb-pagination-links.scss';
</style>
